import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { appConfig } from '~/appConfig';

import { ru } from '../../../public/locales/ru/ru';

export const resources = {
  ru,
};

// Needs import to index.tsx to be bundled
void i18n.use(initReactI18next).init({
  resources,
  defaultNS: 'common',
  lng: appConfig.defaultLanguage,
  compatibilityJSON: 'v3',
  returnNull: false,
  interpolation: {
    escapeValue: false,
  },
});

export { i18n };
